// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileOutlinedSvg from "@fishx/icons-svg/es/asn/FileOutlined";
import FishxIcon from '../components/FishxIcon';

var FileOutlined = function FileOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileOutlinedSvg
  }));
};

FileOutlined.displayName = 'FileOutlined';
export default React.forwardRef(FileOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileOutlined.js
// module id = 2728
// module chunks = 0